import { getLocalAudioBaseUrl } from "./localCourseAudio";
import { SpotlightAudio } from "./types";

const AUDIO_BOOK_DRAWER_STORAGE_KEY = "audioBookDrawerData";

const DEFAULT_WORD_HIGHLIGHT = "lightblue";
const DEFAULT_SENTENCE_HIGHLIGHT = "beige";

export type AudioBookDrawerPreferences = {
  wordHighlightColor: string;
  sentenceHighlightColor: string;
  maxSpotlights?: number;
};

export function readAudioBookDrawerPreferences(): AudioBookDrawerPreferences {
  const defaults: AudioBookDrawerPreferences = {
    wordHighlightColor: DEFAULT_WORD_HIGHLIGHT,
    sentenceHighlightColor: DEFAULT_SENTENCE_HIGHLIGHT,
  };

  try {
    const saved = localStorage.getItem(AUDIO_BOOK_DRAWER_STORAGE_KEY);
    if (!saved) {
      return defaults;
    }
    const parsed = JSON.parse(saved) as Record<string, unknown>;
    const maxRaw = parsed.maxSpotlights;
    return {
      wordHighlightColor:
        typeof parsed.wordHighlightColor === "string"
          ? parsed.wordHighlightColor
          : defaults.wordHighlightColor,
      sentenceHighlightColor:
        typeof parsed.sentenceHighlightColor === "string"
          ? parsed.sentenceHighlightColor
          : defaults.sentenceHighlightColor,
      maxSpotlights:
        maxRaw === "" || maxRaw == null ? undefined : parseInt(String(maxRaw), 10) || undefined,
    };
  } catch {
    return defaults;
  }
}

/** Same spotlight payload as AudioBook drawer submit, using on-disk course audio. */
export function buildLocalSpotlightAudio(packagePath: string): SpotlightAudio {
  const prefs = readAudioBookDrawerPreferences();
  return {
    localAudioBaseUrl: getLocalAudioBaseUrl(packagePath),
    wordHighlightColor: prefs.wordHighlightColor,
    sentenceHighlightColor: prefs.sentenceHighlightColor,
    maxSpotlights: prefs.maxSpotlights,
  };
}

export function buildRemoteSpotlightAudio(
  ttsURL: string,
  prefs: AudioBookDrawerPreferences,
): SpotlightAudio {
  return {
    ttsURL,
    wordHighlightColor: prefs.wordHighlightColor,
    sentenceHighlightColor: prefs.sentenceHighlightColor,
    maxSpotlights: prefs.maxSpotlights,
  };
}
